exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.goods-promotion-tags[data-v-a28762da] {\n  padding: 12px;\n}\n", ""]);

// exports
